import { isDev, isMobile, type SociosApiConfig } from '@capsicum/common';
import { useWindow } from '@capsicum/common-web';

const useACLDevProxyUrl = (config: SociosApiConfig) => {
	const window = useWindow();

	if (!isDev() || isMobile() || window === null) {
		return config;
	}

	const currentURL = window.location;

	if (!['localhost:8080', 'localhost:8081'].includes(currentURL.host)) {
		// eslint-disable-next-line no-restricted-syntax
		console.warn('All request sent to ACL goes through NextJS proxy');

		return {
			...config,
			baseURL: '/api/proxy/acl/'
		};
	}

	return config;
};

export default useACLDevProxyUrl;
